import * as React from "react";
import styled from "styled-components";
import { colors, fonts } from "../../styles";
import Switch, { SwitchClassKey, SwitchProps } from "@material-ui/core/Switch";
import { withStyles, Theme, createStyles } from "@material-ui/core/styles";

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface Props extends SwitchProps {
  classes: Styles;
}

const SBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 20px 0 0px 0;
`;

const SubmarineText = styled.p`
  color: rgb(${colors.white});
  font-size: ${fonts.size.h6};
  // font-family: "NexaDemo-Light";
  margin: 0 20px;
  @media (max-width: 550px) {
    font-size: 16px;
  }
`;

const IOSSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 60,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
      border: "1px solid white",
      borderRadius: 13,
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(34px)",
        // color: theme.palette.common.white,
        color: "#E5E5E5",
        "& + $track": {
          backgroundColor: "limegreen",
          opacity: 1,
        },
      },
    },
    thumb: {
      width: 20,
      height: 20,
      marginTop: 1,
    },
    track: {
      borderRadius: 26 / 2,
      border: `4px solid ${colors.white}`,
      backgroundColor: "red",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
      display: "flex",
      justifyContent: "center",
    },
    checked: {},
    focusVisible: {},
  })
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

interface SubmarineProps {
  onChangeInstructed: (state: boolean) => Promise<boolean>;
  decoyVal: boolean;
  text: string;
}

// const Submarine = () => {
const Submarine: React.FC<SubmarineProps> = ({
  onChangeInstructed,
  decoyVal,
  text,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    await onChangeInstructed(decoyVal);
  };

  return (
    <SBannerWrapper>
      <SubmarineText>{text}</SubmarineText>
      <IOSSwitch
        checked={decoyVal}
        onChange={handleChange}
        name="checkedB"
        value={decoyVal}
      />
    </SBannerWrapper>
  );
};

export default Submarine;
